import { atom, selector, useRecoilValue } from "recoil";

//* sign-up page*//

export const roleState = atom({
  key: "roleState",
  default: null,
});
export const emailState = atom({
  key: "emailState",
  default: "",
});
export const passwordState = atom({
  key: "passwordState",
  default: "",
});
export const confirmPasswordState = atom({
  key: "confirmPasswordState",
  default: "",
});

//* sign-up step 1*//

//* customer/caregiver  *//

/* representative/recipient  */

export const isRecipientState = atom({
  key: "isRecipientState ",
  default: "yes",
});

/* customer/recipient  & caregiver */

export const firstNameState = atom({
  key: "firstNameState ",
  default: "",
});
export const middleNameState = atom({
  key: "middleNameState ",
  default: "",
});
export const lastNameState = atom({
  key: "lastNameState",
  default: "",
});
export const address1State = atom({
  key: "address1State",
  default: "",
});
export const phoneNumberState = atom({
  key: "phoneNumberState",
  default: "",
});
export const address2State = atom({
  key: "address2State",
  default: "",
});
export const faxNumberState = atom({
  key: "faxNumberState",
  default: "",
});
export const countryState = atom({
  key: "countryState",
  default: "",
});
export const cityState = atom({
  key: "cityState",
  default: "",
});
export const provinceState = atom({
  key: "provinceState",
  default: "",
});
export const languageState = atom({
  key: "languageState",
  default: [],
});
export const postalCodeState = atom({
  key: "postalCodeState",
  default: "",
});
export const birthDayState = atom({
  key: "birthDayState",
  default: "",
});
export const birthMonthState = atom({
  key: "birthMonthState",
  default: "",
});
export const birthYearState = atom({
  key: "birthYearState",
  default: "",
});
export const comments1State = atom({
  key: "comments1State",
  default: "",
});
export const genderState = atom({
  key: "genderState",
  default: "",
});
export const phoneNumber2State = atom({
  key: "phoneNumber2State",
  default: "",
});
export const facebookProfileState = atom({
  key: "facebookProfileState",
  default: "",
});
export const linkedinProfileState = atom({
  key: "linkedinProfileState",
  default: "",
});
export const instagramProfileState = atom({
  key: "instagramProfileState",
  default: "",
});
export const welcomeVideoState = atom({
  key: "welcomeVideoState",
  default: "",
});

export const avatarFilePathState = atom({
  key: "avatarFilePathState",
  default: { value: "" },
});
export const avatarFileNameState = atom({
  key: "avatarFileNameState",
  default: "",
});
export const avatarBgUrlState = atom({
  key: "avatarBgUrlState",
  default: null,
});
export const profilePictureState = atom({
  key: "profilePictureState",
  default: null,
});

export const recipientFirstNameState = atom({
  key: "recipientFirstNameState",
  default: "",
});
export const recipientLastNameState = atom({
  key: "recipientLastNameState",
  default: "",
});
export const recipientAddressTypeState = atom({
  key: "recipientAddressTypeState",
  default: "",
});
export const recipientLivesInSeniorResidenceState = atom({
  key: "recipientLivesInSeniorResidenceState",
  default: "",
});
export const recipientSeniorResidenceNameState = atom({
  key: "recipientSeniorResidenceNameState",
  default: "",
});
export const recipientMaritalStatusState = atom({
  key: "recipientMaritalStatusState",
  default: "",
});
export const recipientNameOfSpouseState = atom({
  key: "recipientNameOfSpouseState",
  default: "",
});
export const clscServicesState = atom({
  key: "clscServicesState",
  default: "",
});
export const governmentSubsidiesState = atom({
  key: "governmentSubsidiesState",
  default: "",
});
export const employmentSubsidiesState = atom({
  key: "employmentSubsidiesState",
  default: "",
});

/* customer/representative */

export const representativeFirstNameState = atom({
  key: "representativeFirstNameState ",
  default: "",
});
export const representativeMiddleNameState = atom({
  key: "representativeMiddleNameState ",
  default: "",
});
export const representativeLastNameState = atom({
  key: "representativeLastNameState",
  default: "",
});
export const representativeAddress1State = atom({
  key: "representativeAddress1State",
  default: "",
});
export const representativePhoneNumberState = atom({
  key: "representativePhoneNumberState",
  default: "",
});
export const representativeAddress2State = atom({
  key: "representativeAddress2State",
  default: "",
});
export const representativeFaxNumberState = atom({
  key: "representativeFaxNumberState",
  default: "",
});
export const representativeCountryState = atom({
  key: "representativeCountryState",
  default: "",
});
export const representativeCityState = atom({
  key: "representativeCityState",
  default: "",
});
export const representativeProvinceState = atom({
  key: "representativeProvinceState",
  default: "",
});
export const representativeLanguageState = atom({
  key: "representativeLanguageState",
  default: [],
});
export const representativePostalCodeState = atom({
  key: "representativePostalCodeState",
  default: "",
});
export const representativeBirthDayState = atom({
  key: "representativeBirthDayState",
  default: "",
});
export const representativeBirthMonthState = atom({
  key: "representativeBirthMonthState",
  default: "",
});
export const representativeBirthYearState = atom({
  key: "representativeBirthYearState",
  default: "",
});
export const representativeComments1State = atom({
  key: "representativeComments1State",
  default: "",
});
export const representativeGenderState = atom({
  key: "representativeGenderState",
  default: "",
});
export const relationshipState = atom({
  key: "relationshipState",
  default: "",
});

export const representativePhoneNumber2State = atom({
  key: "representativePhoneNumber2State",
  default: "",
});
export const powerOfAttorneyState = atom({
  key: "powerOfAttorneyState",
  default: "",
});
export const mandateOfRepresentationState = atom({
  key: "mandateOfRepresentationState",
  default: "",
});
export const ableToContactLegallyState = atom({
  key: "ableToContactLegallyState",
  default: "",
});
export const consentOfServiceState = atom({
  key: "consentOfServiceState",
  default: "",
});
export const caregiverArrivalState = atom({
  key: "caregiverArrivalState",
  default: "",
});

//* sign-up step 2*//

/* caregiver*/

export const availableDayState = atom({
  key: "availableDayState ",
  default: "",
});
export const availableMonthState = atom({
  key: "availableMonthState",
  default: "",
});
export const availableYearState = atom({
  key: "availableYearState",
  default: "",
});
export const yearsOfExperienceState = atom({
  key: "yearsOfExperienceState",
  default: "",
});
export const nursingLicenseNumberState = atom({
  key: "nursingLicenseNumberState",
  default: "",
});
export const sinState = atom({
  key: "sinState",
  default: "",
});
export const applyingAsState = atom({
  key: "applyingAsState",
  default: "",
});
export const trainingState = atom({
  key: "trainingState",
  default: "",
});
export const workPermitState = atom({
  key: "workPermitState",
  default: "",
});
export const availableForWorkWithinOneMonthState = atom({
  key: "availableForWorkWithinOneMonthState",
  default: "",
});
export const acceptTermsAndConditionsState = atom({
  key: "acceptTermsAndConditionsState",
  default: "",
});
export const commutingMeansState = atom({
  key: "commutingMeansState",
  default: "",
});
export const preferredHourlyRateState = atom({
  key: "preferredHourlyRateState",
  default: 0,
});
export const currentHourlyRateState = atom({
  key: "currentHourlyRateState",
  default: 0,
});
export const preferredLocationState = atom({
  key: "preferredLocationState",
  default: "",
});
export const culturalBackgroundState = atom({
  key: "culturalBackgroundState",
  default: "",
});
export const workWithDogState = atom({
  key: "workWithDogState",
  default: "",
});
export const workWithCatState = atom({
  key: "workWithCatState",
  default: "",
});
export const climbStairsState = atom({
  key: "climbStairsState",
  default: "",
});
export const workWithSmokerState = atom({
  key: "workWithSmokerState",
  default: "",
});
export const referredByState = atom({
  key: "referredByState",
  default: "",
});
export const requestFromPartnerAgencyState = atom({
  key: "requestFromPartnerAgencyState",
  default: "",
});
export const referencesState = atom({
  key: "referencesState",
  default: "",
});
export const nameReferenceOneState = atom({
  key: "nameReferenceOneState",
  default: "",
});

export const addressReferenceOneState = atom({
  key: "addressReferenceOneState",
  default: "",
});
export const phoneNumberReferenceOneState = atom({
  key: "phoneNumberReferenceOneState",
  default: "",
});
export const emailReferenceOneState = atom({
  key: "emailReferenceOneState",
  default: "",
});
export const nameReferenceTwoState = atom({
  key: "nameReferenceTwoState",
  default: "",
});

export const addressReferenceTwoState = atom({
  key: "addressReferenceTwoState",
  default: "",
});
export const phoneNumberReferenceTwoState = atom({
  key: "phoneNumberReferenceTwoState",
  default: "",
});
export const emailReferenceTwoState = atom({
  key: "emailReferenceTwoState",
  default: "",
});

/* customer */

export const remainAloneState = atom({
  key: "remainAloneState",
  default: "",
});
export const wearDenturesState = atom({
  key: "wearDenturesState",
  default: "",
});
export const hearingImpairedState = atom({
  key: "hearingImpairedState",
  default: "",
});
export const visionImpairedState = atom({
  key: "visionImpairedState",
  default: "",
});
export const showAssistanceState = atom({
  key: "showAssistanceState",
  default: "",
});
export const incontinentState = atom({
  key: "incontinentState",
  default: "",
});
export const toiletAssistanceState = atom({
  key: "toiletAssistanceState",
  default: "",
});
export const walkAssistanceState = atom({
  key: "walkAssistanceState",
  default: "",
});
export const standAssistanceState = atom({
  key: "standAssistanceState",
  default: "",
});

export const transferToVehicleState = atom({
  key: "transferToVehicleState",
  default: "",
});
export const medicationsDispillState = atom({
  key: "medicationsDispillState",
  default: "",
});
export const medicationsContainerState = atom({
  key: "medicationsContainerState",
  default: "",
});
export const medicationsCrashedState = atom({
  key: "medicationsCrashedState",
  default: "",
});
export const medicationsGivenState = atom({
  key: "medicationsGivenState",
  default: "",
});
export const medicationsOrallyState = atom({
  key: "medicationsOrallyState",
  default: "",
});
export const medicationsInjectedState = atom({
  key: "medicationsInjectedState",
  default: "",
});
export const recipientVaccinationState = atom({
  key: "recipientVaccinationState",
  default: "",
});
export const useWalkerState = atom({
  key: "useWalkerState",
  default: "",
});
export const useCaneState = atom({
  key: "useCaneState",
  default: "",
});
export const supervisedWalkingState = atom({
  key: "supervisedWalkingState",
  default: "",
});
export const eatWithoutAssistanceState = atom({
  key: "eatWithoutAssistanceState",
  default: "",
});
export const difficultySwallowingState = atom({
  key: "difficultySwallowingState",
  default: "",
});
export const wearDiapersState = atom({
  key: "wearDiapersState",
  default: "",
});
export const hospitalBedState = atom({
  key: "hospitalBedState",
  default: "",
});
export const oxygenUseState = atom({
  key: "oxygenUseState",
  default: "",
});
export const liftOrOverheadState = atom({
  key: "liftOrOverheadState",
  default: "",
});
export const bathRoomSecurityBarsState = atom({
  key: "bathRoomSecurityBarsState",
  default: "",
});
export const toiletSecurityBarsState = atom({
  key: "toiletSecurityBarsState",
  default: "",
});
export const showerChairState = atom({
  key: "showerChairState",
  default: "",
});
export const adaptedBathroomState = atom({
  key: "adaptedBathroomState",
  default: "",
});
export const useCommodeState = atom({
  key: "useCommodeState",
  default: "",
});
export const haveSuppliesState = atom({
  key: "haveSuppliesState",
  default: "",
});

//* sign-up step 3 *//

export const uploadedDocumentsState = atom({
  key: "uploadedDocumentsState",
  default: [],
});
export const acceptTncState = atom({
  key: "acceptTncState",
  default: "false",
});
export const wantPromoState = atom({
  key: "wantPromoState",
  default: "false",
});
export const vaccinationAmountState = atom({
  key: "vaccinationAmountState",
  default: 0,
});
export const uploadCertificateState = atom({
  key: "uploadCertificateState",
  default: [],
});
export const uploadCPRState = atom({
  key: "uploadCPRState",
  default: [],
});
export const uploadPSDBState = atom({
  key: "uploadPSDBState",
  default: [],
});
export const uploadVoidChequeState = atom({
  key: "uploadVoidChequeState",
  default: [],
});
export const canadianIdState = atom({
  key: "canadianIdState",
  default: [],
});
export const workPermitDocState = atom({
  key: "workPermitDocState",
  default: [],
});

export const covidVaccinationState = atom({
  key: "covidVaccinationState",
  default: [],
});

/* Service offer, Education and Skills section state*/

export const serviceListState = atom({
  key: "serviceListState",
  default: [],
});
export const educationListState = atom({
  key: "educationListState",
  default: [],
});
export const skillsListState = atom({
  key: "skillsListState",
  default: [],
});
export const selectedServiceListState = atom({
  key: "selectedServiceListState",
  default: [],
});
export const selectedSkillsListState = atom({
  key: "selectedSkillsListState",
  default: [],
});
export const selectedEducationListState = atom({
  key: "selectedEducationListState",
  default: [],
});

export const selectCitizenStatus = atom({
  key: "selectCitizenStatus",
  default: "",
});

/*getting value of birth date and availability date */

const dateOfBirthState = selector({
  key: "dateOfBirthState",
  get: ({ get }) => {
    const day = get(birthDayState);
    const month = get(birthMonthState);
    const year = get(birthYearState);

    return `${year}-${month}-${day}`;
  },
});
const availableAsOfDateState = selector({
  key: "availableAsOfDateState",
  get: ({ get }) => {
    const availableDay = get(availableDayState);
    const availableMonth = get(availableMonthState);
    const availableYear = get(availableYearState);

    return `${availableYear}-${availableMonth}-${availableDay}`;
  },
});

const representativeDateOfBirthState = selector({
  key: "representativeDateOfBirthState",
  get: ({ get }) => {
    const day = get(representativeBirthDayState);
    const month = get(representativeBirthMonthState);
    const year = get(representativeBirthYearState);

    return `${year}-${month}-${day}`;
  },
});

//* Caregiver Submit function selector*//

export const caregiverSubmitDataState = selector({
  key: "caregiverSubmitDataState",
  get: ({ get }) => {
    const user_type = get(roleState);
    const email = get(emailState);
    const password = get(passwordState);
    const confirm_password = get(confirmPasswordState);
    const first_name = get(firstNameState);
    const middle_name = get(middleNameState);
    const last_name = get(lastNameState);
    const address = get(address1State);
    const address_line_2 = get(address2State);
    const phone = get(phoneNumberState);
    const fax = get(faxNumberState);
    const country = get(countryState);
    const city = get(cityState);
    const state = get(provinceState);
    const spoken_languages = get(languageState);
    const zip = get(postalCodeState);

    const birth_date = get(dateOfBirthState);

    const bio = get(comments1State);
    const gender = get(genderState);
    const phone_2 = get(phoneNumber2State);
    const facebook_profile = get(facebookProfileState);
    const linkedin_profile = get(linkedinProfileState);
    const instagram_profile = get(instagramProfileState);
    const welcome_video = get(welcomeVideoState);

    const available_as_of_date = get(availableAsOfDateState);

    const years_experience = get(yearsOfExperienceState);
    const nursing_license_number = get(nursingLicenseNumberState);
    const sin = get(sinState);
    const applying_as = get(applyingAsState);
    const training = get(trainingState);
    const able_to_work = get(workPermitState);
    const preferred_hourly_rate = get(preferredHourlyRateState);
    const current_hourly_rate = get(currentHourlyRateState);
    const profile_picture = get(profilePictureState);
    const work_within_1_month = get(availableForWorkWithinOneMonthState);

    const how_commute = get(commutingMeansState);
    const location_of_work = get(preferredLocationState);
    const cultural_background_caregiver = get(culturalBackgroundState);
    const work_with_dog = get(workWithDogState);
    const work_with_cat = get(workWithCatState);
    const go_up_down_stairs = get(climbStairsState);
    const work_with_smoker = get(workWithSmokerState);
    const referred_by = get(referredByState);
    const care_requests_from_partner = get(requestFromPartnerAgencyState);
    const references = get(referencesState);

    const accept_terms_services = get(acceptTncState);

    const training_document = get(uploadCertificateState);
    const citizenship_status = get(selectCitizenStatus);

    const proof_vaccination = get(covidVaccinationState);
    const void_cheque = get(uploadVoidChequeState);
    const canadian_id = get(canadianIdState);
    const work_permit = get(workPermitDocState);
    const cpr_doc = get(uploadCPRState);
    const psdb_doc = get(uploadPSDBState);

    const other_documents = get(uploadedDocumentsState);

    const services = get(selectedServiceListState);
    const skills = get(selectedSkillsListState);
    const education_diplomas = get(selectedEducationListState);

    // const nameReferenceOne = get(nameReferenceOneState);
    // const addressReferenceOne = get(addressReferenceOneState);
    // const phoneNumberReferenceOne = get(phoneNumberReferenceOneState);
    // const emailReferenceOne = get(emailReferenceOneState);
    // const nameReferenceTwo = get(nameReferenceTwoState);
    // const addressReferenceTwo = get(addressReferenceTwoState);
    // const phoneNumberReferenceTwo = get(phoneNumberReferenceTwoState);
    // const emailReferenceTwo = get(emailReferenceTwoState);

    // const wantPromo = get(wantPromoState);

    return {
      user_type,
      email,
      password,
      confirm_password,
      first_name,
      middle_name,
      last_name,
      address,
      address_line_2,
      phone,
      phone_2,
      fax,
      country,
      city,
      state,
      spoken_languages,
      zip,
      birth_date,
      bio,
      gender,
      facebook_profile,
      linkedin_profile,
      instagram_profile,
      welcome_video,
      profile_picture,
      available_as_of_date,

      years_experience,
      nursing_license_number,
      sin,
      applying_as,
      training,
      able_to_work,
      work_within_1_month,

      how_commute,
      preferred_hourly_rate,
      current_hourly_rate,
      location_of_work,
      work_with_dog,
      work_with_cat,
      go_up_down_stairs,
      cultural_background_caregiver,
      work_with_smoker,
      referred_by,
      care_requests_from_partner,
      references,
      accept_terms_services,
      citizenship_status,
      training_document,
      void_cheque,
      canadian_id,
      work_permit,
      proof_vaccination,
      cpr_doc,
      psdb_doc,

      services,
      skills,
      education_diplomas,

      other_documents,

      // nameReferenceOne,
      // addressReferenceOne,
      // phoneNumberReferenceOne,
      // emailReferenceOne,
      // nameReferenceTwo,
      // addressReferenceTwo,
      // phoneNumberReferenceTwo,
      // emailReferenceTwo,

      // wantPromo,
    };
  },
});

// Customer Submit function selector*//

// Recipient is customer and no representative

export const recipientSubmitDataState = selector({
  key: "recipientSubmitDataState",
  get: ({ get }) => {
    const user_type = get(roleState);
    const email = get(emailState);
    const password = get(passwordState);
    const confirm_password = get(confirmPasswordState);

    const first_name = get(firstNameState);
    const middle_name = get(middleNameState);
    const last_name = get(lastNameState);
    const address = get(address1State);
    const address_line_2 = get(address2State);
    const phone = get(phoneNumberState);
    const fax = get(faxNumberState);
    const country = get(countryState).toUpperCase();
    const city = get(cityState);
    const state = get(provinceState).toLowerCase();
    const spoken_languages = get(languageState);
    const zip = get(postalCodeState);
    const birth_date = get(dateOfBirthState);
    const notes = get(comments1State);
    const gender = get(genderState);
    const phone2 = get(phoneNumber2State);

    const profile_picture = get(profilePictureState);

    const recipient_address_type = get(recipientAddressTypeState);



    const recipient_martial_status = get(recipientMaritalStatusState);
    const recipient_name_of_spouse = get(recipientNameOfSpouseState);
    const recipient_is_senior_residence = get(recipientLivesInSeniorResidenceState);
    const recipient_senior_residence_name = get(recipientSeniorResidenceNameState);
    const clsc_service_received = get(clscServicesState);
    const government_subsidies = get(governmentSubsidiesState);
    const ces_cheque_emplois_service = get(employmentSubsidiesState);

    const recepient_of_service = get(isRecipientState);

    const recipient_vaccination_status = get(recipientVaccinationState);

    const recipient_remain_alone = get(remainAloneState);
    const recipient_wear_dentures = get(wearDenturesState);
    const recipient_hearing_impaired = get(hearingImpairedState);
    const recipient_vision_impaired = get(visionImpairedState);
    const recipient_show_assistance = get(showAssistanceState);
    const recipient_incontinent = get(incontinentState);
    const recipient_toilet_assistance = get(toiletAssistanceState);
    const recipient_walk_assistance = get(walkAssistanceState);
    const recipient_use_cane = get(useCaneState);
    const recipient_transfer_vehicule_with_assistance = get(transferToVehicleState);
    const recipient_stand_with_assistance = get(standAssistanceState);

    const recipient_supervised_walk_walking = get(supervisedWalkingState);
    const recipient_diapers = get(wearDiapersState);
    const recipient_use_walker = get(useWalkerState);

    const recipient_eat_without_assitance = get(eatWithoutAssistanceState);
    const recipient_difficulty_swallowing = get(difficultySwallowingState);

    const recipient_hospital_bed = get(hospitalBedState);
    const recipient_oxygen_used = get(oxygenUseState);
    const recipient_lift = get(liftOrOverheadState);
    const recipient_security_bars_bathroom = get(bathRoomSecurityBarsState);
    const recipient_shower_chair = get(showerChairState);
    const recipient_security_bars_toilet = get(toiletSecurityBarsState);
    const recipient_adapted_bathroom = get(adaptedBathroomState);
    const recipient_commode_used = get(useCommodeState);
    const recipient_supplies = get(haveSuppliesState);

    const recipient_meds_in_dispill = get(medicationsDispillState);
    const recipient_meds_taken_original_container = get(medicationsContainerState);
    const recipient_meds_be_crushed = get(medicationsCrashedState);
    const recipient_medications_given = get(medicationsGivenState);
    const recipient_meds_given_orally = get(medicationsOrallyState);
    const recipient_meds_injected = get(medicationsInjectedState);

    const cargiver_services = get(selectedServiceListState);

    const accept_terms_services = get(acceptTncState);

    return {
      user_type,
      email,
      password,
      confirm_password,
      first_name,
      middle_name,
      last_name,
      address,
      address_line_2,
      phone,
      phone2,
      fax,
      country,
      city,
      state,
      spoken_languages,
      zip,
      birth_date,
      notes,
      gender,
      profile_picture,
      recipient_address_type,

      recipient_martial_status,
      recipient_name_of_spouse,
      recipient_is_senior_residence,
      recipient_senior_residence_name,
      clsc_service_received,
      government_subsidies,
      ces_cheque_emplois_service,

      recepient_of_service,

      recipient_remain_alone,
      recipient_wear_dentures,
      recipient_hearing_impaired,
      recipient_vision_impaired,
      recipient_show_assistance,
      recipient_incontinent,
      recipient_toilet_assistance,
      recipient_walk_assistance,
      recipient_use_cane,
      recipient_transfer_vehicule_with_assistance,
      recipient_stand_with_assistance,

      recipient_vaccination_status,

      recipient_supervised_walk_walking,
      recipient_diapers,
      recipient_use_walker,

      recipient_eat_without_assitance,
      recipient_difficulty_swallowing,

      recipient_hospital_bed,
      recipient_oxygen_used,
      recipient_lift,
      recipient_security_bars_bathroom,
      recipient_shower_chair,
      recipient_security_bars_toilet,
      recipient_adapted_bathroom,
      recipient_commode_used,
      recipient_supplies,

      recipient_meds_in_dispill,
      recipient_meds_taken_original_container,
      recipient_medications_given,
      recipient_meds_given_orally,
      recipient_meds_be_crushed,
      recipient_meds_injected,

      cargiver_services,
      accept_terms_services,
    };
  },
});

// Representative is customer and recipient is recipient

export const representativeSubmitDataState = selector({
  key: "representativeSubmitDataState",
  get: ({ get }) => {
    const user_type = get(roleState);
    const email = get(emailState);
    const password = get(passwordState);
    const confirm_password = get(confirmPasswordState);

    const first_name = get(representativeFirstNameState);
    const middle_name = get(representativeMiddleNameState);
    const last_name = get(representativeLastNameState);
    const address = get(representativeAddress1State);
    const address_line_2 = get(representativeAddress2State);
    const phone = get(representativePhoneNumberState);
    const fax = get(representativeFaxNumberState);
    const country = get(representativeCountryState);
    const city = get(representativeCityState);
    const state = get(representativeProvinceState);
    const spoken_languages = get(representativeLanguageState);
    const zip = get(representativePostalCodeState);
    const birth_date = get(representativeDateOfBirthState);

    const gender = get(representativeGenderState);
    const phone_2 = get(representativePhoneNumber2State);
    const relationship = get(relationshipState);

    const power_of_attorney = get(powerOfAttorneyState);
    const mandate_of_representation = get(mandateOfRepresentationState);
    const legal_contact = get(ableToContactLegallyState);
    const consent_of_service = get(consentOfServiceState);
    const caregiver_arrival = get(caregiverArrivalState);

    const recipient_first_name = get(firstNameState);
    const recipient_last_name = get(lastNameState);
    const recipient_address = get(address1State);
    const recipient_address_line_2 = get(address2State);
    const recipient_phone = get(phoneNumberState);
    const recipient_fax = get(faxNumberState);
    const recipient_country = get(countryState).toUpperCase();
    const recipient_city = get(cityState);
    const recipient_state = get(provinceState).toLowerCase();
    const recipient_spoken_languages = get(languageState);
    const recipient_zip = get(postalCodeState);
    const recipient_birth_date = get(dateOfBirthState);

    const recipient_gender = get(genderState);
    const recipient_phone_2 = get(phoneNumber2State);

    const notes = get(comments1State);

    const profile_picture = get(profilePictureState);

    const recipient_address_type = get(recipientAddressTypeState);

    const recipient_martial_status = get(recipientMaritalStatusState);
    const recipient_name_of_spouse = get(recipientNameOfSpouseState);
    const recipient_is_senior_residence = get(recipientLivesInSeniorResidenceState);
    const recipient_senior_residence_name = get(recipientSeniorResidenceNameState);
    const clsc_service_received = get(clscServicesState);
    const government_subsidies = get(governmentSubsidiesState);
    const ces_cheque_emplois_service = get(employmentSubsidiesState);

    const recepient_of_service = get(isRecipientState);

    const recipient_vaccination_status = get(recipientVaccinationState);

    const recipient_remain_alone = get(remainAloneState);
    const recipient_wear_dentures = get(wearDenturesState);
    const recipient_hearing_impaired = get(hearingImpairedState);
    const recipient_vision_impaired = get(visionImpairedState);
    const recipient_show_assistance = get(showAssistanceState);
    const recipient_incontinent = get(incontinentState);
    const recipient_toilet_assistance = get(toiletAssistanceState);
    const recipient_walk_assistance = get(walkAssistanceState);
    const recipient_use_cane = get(useCaneState);
    const recipient_transfer_vehicule_with_assistance = get(transferToVehicleState);
    const recipient_stand_with_assistance = get(standAssistanceState);

    const recipient_supervised_walk_walking = get(supervisedWalkingState);
    const recipient_diapers = get(wearDiapersState);
    const recipient_use_walker = get(useWalkerState);

    const recipient_eat_without_assitance = get(eatWithoutAssistanceState);
    const recipient_difficulty_swallowing = get(difficultySwallowingState);

    const recipient_hospital_bed = get(hospitalBedState);
    const recipient_oxygen_used = get(oxygenUseState);
    const recipient_lift = get(liftOrOverheadState);
    const recipient_security_bars_bathroom = get(bathRoomSecurityBarsState);
    const recipient_shower_chair = get(showerChairState);
    const recipient_security_bars_toilet = get(toiletSecurityBarsState);
    const recipient_adapted_bathroom = get(adaptedBathroomState);
    const recipient_commode_used = get(useCommodeState);
    const recipient_supplies = get(haveSuppliesState);

    const recipient_meds_in_dispill = get(medicationsDispillState);
    const recipient_meds_taken_original_container = get(medicationsContainerState);
    const recipient_meds_be_crushed = get(medicationsCrashedState);
    const recipient_medications_given = get(medicationsGivenState);
    const recipient_meds_given_orally = get(medicationsOrallyState);
    const recipient_meds_injected = get(medicationsInjectedState);

    const cargiver_services = get(selectedServiceListState);

    const accept_terms_services = get(acceptTncState);

    return {
      user_type,
      email,
      password,
      confirm_password,
      first_name,
      middle_name,
      last_name,
      address,
      address_line_2,
      phone,
      phone_2,
      fax,
      country,
      city,
      state,
      spoken_languages,
      zip,
      birth_date,
      notes,
      gender,
      profile_picture,

      relationship,
      power_of_attorney,
      mandate_of_representation,
      legal_contact,
      consent_of_service,
      caregiver_arrival,

      recipient_first_name,
      recipient_last_name,
      recipient_address,
      recipient_address_line_2,
      recipient_phone,
      recipient_phone_2,
      recipient_fax,
      recipient_country,
      recipient_city,
      recipient_state,
      recipient_spoken_languages,
      recipient_zip,
      recipient_birth_date,
      recipient_gender,

      recipient_address_type,
      recipient_martial_status,
      recipient_name_of_spouse,
      recipient_is_senior_residence,
      recipient_senior_residence_name,
      clsc_service_received,
      government_subsidies,
      ces_cheque_emplois_service,

      recepient_of_service,

      recipient_remain_alone,
      recipient_wear_dentures,
      recipient_hearing_impaired,
      recipient_vision_impaired,
      recipient_show_assistance,
      recipient_incontinent,
      recipient_toilet_assistance,
      recipient_walk_assistance,
      recipient_use_cane,
      recipient_transfer_vehicule_with_assistance,
      recipient_stand_with_assistance,

      recipient_vaccination_status,

      recipient_supervised_walk_walking,
      recipient_diapers,
      recipient_use_walker,

      recipient_eat_without_assitance,
      recipient_difficulty_swallowing,

      recipient_hospital_bed,
      recipient_oxygen_used,
      recipient_lift,
      recipient_security_bars_bathroom,
      recipient_shower_chair,
      recipient_security_bars_toilet,
      recipient_adapted_bathroom,
      recipient_commode_used,
      recipient_supplies,

      recipient_meds_in_dispill,
      recipient_meds_taken_original_container,
      recipient_medications_given,
      recipient_meds_given_orally,
      recipient_meds_be_crushed,
      recipient_meds_injected,

      cargiver_services,
      accept_terms_services,
    };
  },
});
